import React, { useContext, useState } from "react";
import { renderStatementWithKaTeX } from "../../../../../Status";
import "./ProblemSolutions.css";
import { AuthContext } from "../../../../../context/authContext";
import { EditingProblemByReferenceCode } from "../../../../../Functions/CRUD/Problem/problemHelper";
import { deleteSolution } from "../../../../../Functions/CRUD/Problem/problemHelper";


const ProblemSolutions = ({ problem,setLoading }) => {
  const { user } = useContext(AuthContext);
  const [SolutionsSet, setSolutionsSet] = useState(problem.solution);
  const [SolutionAttempt, setSolutionAttempt] = useState("");
  const [Link, setLink] = useState("")
  const marker="***additional url***"
  return (
    <div className="ProblemSolutions-container">
      <h1>Soltuions : </h1>
      <div className="PostedSolutions-container">
        {SolutionsSet[1] ? (
          SolutionsSet.slice(1).map((el, index) => {
           
  const [solution, url = ""] = el.split(marker);

  return (
    <div className="PostedSolution" key={index}>
      <div className="SoltuionHeader">
  <h2>Solution n°{index + 1}:</h2>

        <button className="deleteSolutionButton" onClick={() => {deleteSolution(problem.referenceCode,index); setSolutionsSet(prev =>
      prev.filter((_, i) => i !== index)
    );}}>
    Delete solution
  </button>
      </div>

  <span>{renderStatementWithKaTeX(solution.trim())}</span>

  {url.trim() && (
    <p>
      View pinned document here:
      <a
        href={url.trim()}
        target="_blank"
        rel="noopener noreferrer"
      >
        click here
      </a>
    </p>
  )}

  

  <hr />
</div>
  );
})
        ) : (
          <div className="Error">No solution is posted yet ...</div>
        )}
      </div>

      <div className="keyboard">
        <h2>Submit your own Solution :</h2>
        <div className="over-view">
          {renderStatementWithKaTeX(
            SolutionAttempt +
              `\n\n ( Written by $\\textit{` +
              user.username +
              `}$ )`,
          )}
        </div>

        <form className="SolutionAttemptForm" action="">
          <textarea
            required
            type="text"
            placeholder="Start writing your solution over here ..."
            value={SolutionAttempt}
            onChange={(e) => {
              setSolutionAttempt(e.target.value);
            }}
          />
          <label htmlFor="">Include a figure from your drive (don't forget to make grant public access):</label>
          <input 
          type="url"
          value={Link}
            onChange={(e) => {
              setLink(e.target.value);
            }}   placeholder="include link here ..."/>

            <button
          type="submit"
          className="Submit-button" /* onClick={test.role!="Student"?()=>{setCorrectionStatus(PrimarySubmissionStatus)}:null} */
          
          onClick={async () => {
  if (!SolutionAttempt.trim()) return;
setLoading(true)
  const newSolution =
    SolutionAttempt +
    `\n\n ( Written by $\\textit{${user.username}}$ )`+(Link?marker+Link:"");

  const newSolutions = [...SolutionsSet, newSolution];

  setSolutionsSet(newSolutions);

  await EditingProblemByReferenceCode(problem.referenceCode, {
    solution: newSolutions,
  });

  setSolutionAttempt("");
  setLoading(false);
  window.location.reload()
}}
        >
          Submit
        </button>
        </form>

        
      </div>
    </div>
  );
};

export default ProblemSolutions;
